import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import i18n from '../i18n'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect: `/${i18n.locale}`
  // },
  // {
  //   path: '/:lang',
  //   component: {
  //     render (c) { return c('router-view') }
  //   },
  //   children: [
  //     {
  //       path: '/',
  //       name: 'Home',
  //       component: Home
  //     },
  //     {
  //       path: '*',
  //       name: '/',
  //       component: Home
  //     },
  //     {
  //       path: '/new-member',
  //       name: 'NewMember',
  //       component: () => import('../views/MemberRegistration')
  //     },
  //     {
  //       path: '/member-login',
  //       name: 'MemberLogin',
  //       component: () => import('../views/MemberLogin')
  //     },
  //     {
  //       path: '/corporate-login',
  //       name: 'CorporateLogin',
  //       component: () => import('../views/CorporateLogin')
  //     },
  //     {
  //       path: '/booking',
  //       name: 'Booking',
  //       component: () => import('../views/Booking'),
  //       meta: {
  //         requiresAuth: true,
  //       }
  //     },
  //     {
  //       path: '/thankyou',
  //       name: 'ThankYou',
  //       component: () => import('../views/ThankYou'),
  //       meta: {
  //         requiresAuth: true,
  //       }
  //     },
  //   ]   
  // }
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '*',
    name: '/',
    component: Home
  },
  {
    path: '/new-member',
    name: 'NewMember',
    component: () => import('../views/MemberRegistration')
  },
  {
    path: '/member-login',
    name: 'MemberLogin',
    component: () => import('../views/MemberLogin')
  },
  {
    path: '/corporate-login',
    name: 'CorporateLogin',
    component: () => import('../views/CorporateLogin')
  },
  {
    path: '/booking',
    name: 'Booking',
    component: () => import('../views/Booking'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    component: () => import('../views/ThankYou'),
    meta: {
      requiresAuth: true,
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
